export const REQUEST_STATUS_OPTIONS: { [key: string]: string } = {
  PENDING: 'pending',
  APPROVED: 'approved',
  DECLINED: 'declined',
  CANCELLED: 'cancelled',
  RESCHEDULED: 'rescheduled'
};

export const ATTENDANCE_STATUS_OPTIONS: { [key: string]: string } = {
  DEFAULT: 'default',
  LATE: 'late',
  NO_SHOW: 'no-show'
};

export const SCHEDULE_FLOW_STEPS: { [key: string]: string } = {
  SELECT_DENTIST: 'selectDentist',
  SELECT_PURPOSE: 'selectPurpose',
  SELECT_DATE: 'selectDate',
  SELECT_TIME: 'selectTime',
  SIGN_UP: 'signUp',
  VERIFICATION: 'verification',
  CONFIRMATION: 'confirmation',
  THANK_YOU: 'thankYou'
};

export const GENDER_OPTIONS: { [key: string]: string } = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other'
};

export const MOBILE_NUMBER_LENGTH: number = 10;
export const OTP_LENGTH: number = 6;

export const MINIMUM_AGE_IN_YEARS: number = 1;
export const MINIMUM_AGE_IN_WORDS: string = 'one year';

export const TIMESLOT_BUFFER_IN_HOURS: number = 3;

export const SELECT_MODAL_OTHERS: string = 'Others';

export const AVATAR_COLORS = {
  BLUE: 'blue',
  GREEN: 'green',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  BLACK: 'black',
  VIOLET: 'violet'
};

export const ACCESS_TYPES = {
  EDIT: 'edit',
  VIEW: 'view'
};

export const PURPOSE_JOIN_SEPARATOR: string = ', ';

export const SPECIALIZATION_OPTIONS: { [key: string]: string } = {
  ANESTHESIOLOGY: 'Dental Anesthesiology',
  COSMETIC: 'Cosmetic Dentistry',
  ENDODONTICS: 'Endodontics',
  GENERAL: 'General Dentistry',
  GERIATRIC: 'Geriatric Dentistry',
  ORTHODONTICS: 'Orthodontics',
  PATHOLOGY: 'Oral Pathology',
  PEDIATRICS: 'Pediatric Dentistry',
  PERIODONTICS: 'Periodontics',
  PROSTHODONTICS: 'Prosthodontics',
  RADIOLOGY: 'Oral Radiology',
  RESTORATIVE: 'Restorative Dentistry',
  SURGERY: 'Oral Surgery',
  TMJ: 'TMJ Specialist'
};

export const FACEBOOK_MESSENGER_URL: string = 'https://m.me/OdontoPhilippines';
export const GOOGLE_PLAY_STORE_URL: string =
  'https://play.google.com/store/apps/details?id=ph.odonto.dashboard';
export const APP_STORE_URL: string =
  'https://apps.apple.com/ph/app/odonto/id6737960471';

export const MAXIMUM_DATE_RANGE_IN_MONTHS: number = 3;

export const CLUB_URL: string =
  'https://invite.viber.com/?g=a0p0EqXrJlSdOHD5wdWCWYPJCPFMHXJW';

export const DEFAULT_DURATION_IN_MINUTES: number = 30;
export const OVERLAP_TIME_REDUCTION_IN_MINUTES: number = 0;
export const MAXIMUM_DURATION_IN_MINUTES: number = 120;

export const CLINIC_NAME_IDENTIFIERS: string[] = [
  'Dental',
  'Dental Center',
  'Clinic',
  'Teeth'
];

export const TABLES: { [key: string]: string } = {
  CLINIC_GROUPS: 'clinic_groups',
  CLINICS: 'clinics',
  DENTIST_HOURS: 'dentist_hours',
  DENTISTS: 'dentists',
  PATIENTS: 'patients',
  REQUESTS: 'requests',
  SERVICES: 'services',
  SHARES: 'shares'
};

export const TABLES_WITH_DELETED_AT: string[] = [TABLES.DENTISTS];
